import { Categories } from "./Types"

export function getIcon(category: string): string {

  const result = Categories.find(a => category.toLowerCase() === a.name)
  if (result) return result.icon
  return 'fasldr fa-book'

}

